import React from 'react'
import { FormattedMessage, defineMessages } from 'react-intl'

import CMTTranslations from 'state/actions/CMT/Notifications/translations'

export const SEARCH_INPUT_MIN_LENGTH = 2
export const SEARCH_INPUT_MAX_LENGTH = 70

export const DEFAULT_DWH_TYPE_RECOMENDATION = 'personal_recommendation'
export const LANDING_CLANS_HEADER = <FormattedMessage id="landing.clans.header" defaultMessage="ПОДБОР КЛАНА" />

export const LANDING_CLANS_SUBTITLE = (
    <FormattedMessage
        id="landing.clans.subtitle"
        defaultMessage="Кланы, подходящие под ваши игровые предпочтения и активность."
    />
)

export const LANDING_CLANS_ERROR_COOLDOWN = defineMessages({
    accountInCooldown: {
        id: 'landing.clans.error.cooldown',
        defaultMessage: 'Вы недавно покинули клан. Вы сможете вступить в клан {date} в {time}',
    },
})

export const LANDING_CLANS_ERROR_TITLE = (
    <FormattedMessage id="landing.clans.error.title" defaultMessage="Ошибка загрузки данных" />
)

export const LANDING_CLANS_ERROR_MESSAGE = (
    <FormattedMessage
        id="landing.clans.error.message"
        defaultMessage="Приносим свои извинения за временные неудобства"
    />
)

export const LANDING_CLANS_ERROR_BUTTON = <FormattedMessage id="landing.clans.error.button" defaultMessage="Обновить" />

export const LANDING_CLANS_SUBTITLE_SEARCH = (
    <FormattedMessage
        id="landing.clans.subtitle_search"
        defaultMessage="Кланы, которые удалось найти по тегу и названию."
    />
)

export const LANDING_SEARCH_LABEL = <FormattedMessage id="landing.search.label" defaultMessage="Поиск клана" />

export const LANDING_SEARCH_PLACEHOLDER = (
    <FormattedMessage id="landing.search.placeholder" defaultMessage="Название или тег" />
)

export const LANDING_SEARCH_BUTTON = <FormattedMessage id="landing.search.button" defaultMessage="Искать" />

export const LANDING_SEARCH_BUTTON_DISABLED_ID = 'landing.search.button.disabled.tooltip.id'
export const LANDING_SEARCH_BUTTON_DISABLED = (
    <FormattedMessage
        id="landing.search.button.disabled"
        defaultMessage="Введите как минимум 2 символа для поиска клана"
    />
)

export const LANDING_CLANS_EMPTY_MESSAGE = (
    <FormattedMessage
        id="landing.clans_table.empty_message"
        defaultMessage="Кланы, подходящие под указанные игровые предпочтения, не найдены"
    />
)

export const LANDING_CLANS_EMPTY_SEARCH_MESSAGE = (
    <FormattedMessage
        id="landing.clans_table.empty_search_message"
        defaultMessage="Кланы с таким названием или тегом не найдены"
    />
)

export const LANDING_CLANS_STAT_PLATOONS = (
    <FormattedMessage id="landing.clans.stat.platoons" defaultMessage="Взводы" />
)

export const LANDING_CLANS_STAT_STRONGHOLDS = (
    <FormattedMessage id="landing.clans.stat.strongholds" defaultMessage="Укрепрайоны, уровень" />
)

export const LANDING_CLANS_STAT_GLOBAL_MAP = (
    <FormattedMessage id="landing.clans.stat.global_map" defaultMessage="Глобальная карта" />
)

export const LANDING_CLANS_STAT_RESERVES = (
    <FormattedMessage
        id="landing.clans.stat.reserves"
        defaultMessage="Использование клановых резервов"
    />
)

export const LANDING_CLANS_STAT_VICTORIES = (
    <FormattedMessage id="landing.clans.stat.victories" defaultMessage="Средний процент побед" />
)

export const LANDING_CLANS_STAT_LEVEL = (
    <FormattedMessage id="landing.clans.stat.level" defaultMessage="Уровень Укрепрайона" />
)

export const LANDING_CLANS_STAT_PLAYERS = (
    <FormattedMessage id="landing.clans.stat.players" defaultMessage="Личный состав" />
)

export const LANDING_CLANS_STAT_BATTLES = (
    <FormattedMessage id="landing.clans.stat.battles" defaultMessage="Среднее количество боев" />
)

export const LANDING_CLANS_DESCRITION = (
    <FormattedMessage id="landing.clans.description" defaultMessage="Описание клана" />
)

export const LANDING_CLANS_NO_DESCRITION = (
    <FormattedMessage id="landing.clans.no_description" defaultMessage="У клана пока нет описания." />
)

export const LANDING_CLANS_PROFILE_TOOLTIP = (
    <FormattedMessage id="landing.clans.profile_tooltip" defaultMessage="Открыть профиль этого клана" />
)

export const LANDING_CLANS_APPLIED = <FormattedMessage id="landing.clans.applied" defaultMessage="Заявка отправлена" />

export const LANDING_CLANS_DISABLED_FILTER_TOOLTIP = (
    <FormattedMessage
        id="landing.clans_table.disabled_filter.tooltip"
        defaultMessage="Для подбора клана при помощи фильтров, очистите поле поиска"
    />
)

export const JOIN_CLAN_BUTTON_TITLE = (
    <FormattedMessage id="recommended_clans.button.join_clan" defaultMessage="Вступить в клан" />
)

export const SEND_APPLY_BUTTON_TITLE = (
    <FormattedMessage id="recommended_clans.button.send_apply" defaultMessage="Отправить заявку" />
)

export const CLANS_DISBANDED_TOOLTIP = (
    <FormattedMessage id="recommended_clans.tooltip.disbanded" defaultMessage="Клан расформирован" />
)

export const FILTERS_BUTTON = (
    <FormattedMessage id="recommended_clans.filters.button" defaultMessage="Игровые предпочтения" />
)

export const SEARCH_CONTROL_RESULT = (
    <FormattedMessage id="recommended_clans.search_control.result" defaultMessage="Результат поиска:" />
)

export const LANDING_CLANS_SPINNER = <FormattedMessage id="landing.clans.spinner" defaultMessage="Поиск клана..." />

export const LANDING_CLANS_FILTER_SPINNER = (
    <FormattedMessage id="landing.clans.filter.spinner" defaultMessage="Применение изменений..." />
)

export const NOTIFICATION_MESSAGES = defineMessages({
    clanIsFull: {
        id: 'recommended_clans.notifications.clan_is_full',
        defaultMessage: 'Клан отправил вам приглашение, но сейчас в нём максимальное количество бойцов.',
    },
    recruitingPolicyMismatch: {
        id: 'recommended_clans.notifications.recruiting_policy_mismatch',
        defaultMessage: 'В клан можно вступить только по приглашению',
    },
    inviteDoesNotExist: {
        id: 'recommended_clans.notifications.invite_does_not_exist',
        defaultMessage: 'В клан можно вступить только по приглашению',
    },
    clanIsNotActive: {
        id: 'recommended_clans.notifications.clan_is_not_active',
        defaultMessage: 'Клан расформирован',
    },
    recruitingRestrictionsMismatch: {
        id: 'recommended_clans.notifications.recruiting_restrictions_mismatch',
        defaultMessage: 'Клан изменил условия набора бойцов',
    },
    accountInCooldown: {
        id: 'recommended_clans.notifications.account_in_cooldown',
        // eslint-disable-next-line max-len
        defaultMessage: 'Клан отправил вам приглашение, но вы недавно покинули клан. Вы сможете вступить в клан {date} в {time}',
    },
    actionIsNotAvailable: {
        id: 'recommended_clans.notifications.action_is_not_available',
        defaultMessage: 'Действие недоступно',
    },
    accountIsClanLeader: {
        id: 'recommended_clans.notifications.account_is_clan_leader',
        defaultMessage: 'Вы командующий клана и не можете его покинуть, находясь на этой должности.',
    },
    commonError: {
        id: 'recommended_clans.notifications.common_error',
        defaultMessage: 'Ошибка: не удалось совершить действие',
    },
    applicationSent: {
        id: 'recommended_clans.notifications.application_sent',
        defaultMessage: 'Заявка в клан отправлена',
    },
})
NOTIFICATION_MESSAGES.excludedFromClan = CMTTranslations.excluded_from_clan

// For details proceed to https://stash.wargaming.net/projects/clanwars/repos/wgcg/browse/src/common/exceptions.py#6
export const GATEWAY_ERROR_CODES_FOR_NOTIFICATIONS = {
    18: 'clanIsFull',
    21: 'recruitingPolicyMismatch',
    24: 'inviteDoesNotExist',
    29: 'excludedFromClan',
    30: 'clanIsNotActive',
    51: 'accountIsClanLeader',
    67: 'recruitingRestrictionsMismatch',
}

export const LANDING_CLANS_WAITING = (
    <FormattedMessage id="recommended_clans.tooltips.waiting" defaultMessage="Пожалуйста, подождите..." />
)

export const TOOLTIP_BY_ERROR_CODE = {
    18: (
        <FormattedMessage
            id="recommended_clans.tooltips.clan_is_full"
            defaultMessage="Клан отправил вам приглашение, но сейчас в нём максимальное количество бойцов."
        />
    ),
    21: (
        <FormattedMessage
            id="recommended_clans.tooltips.invite_does_not_exist"
            defaultMessage="В клан можно вступить только по приглашению"
        />
    ),
}



// WEBPACK FOOTER //
// ./containers/Landing/components/LandingClans/constants.js